import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { ChipGroup } from "@/components/ChipGroup";
import { STAGES, STAGE_LABELS, LOSS_REASONS } from "@/lib/constants";
import { Check } from "lucide-react";

const ORDER = ["AWARENESS", "ENGAGEMENT", "DISCOVERY", "PROPOSAL", "WON"];

export const StageStepper = ({ lead, disabled, onChange, canReopen }) => {
  const [lossOpen, setLossOpen] = useState(false);
  const [reason, setReason] = useState(null);
  const cur = lead.lifecycle_stage;
  const closed = ["WON", "LOST"].includes(cur);
  const idx = ORDER.indexOf(cur);
  const click = (s) => {
    if (disabled || s === cur || (closed && !canReopen)) return;
    if (s === "LOST") return setLossOpen(true);
    onChange({ lifecycle_stage: s });
  };
  return (
    <div className="no-scrollbar flex gap-2 overflow-x-auto" data-testid="stage-stepper">
      {STAGES.map((s) => {
        const done = s !== "LOST" && idx >= 0 && ORDER.indexOf(s) < idx;
        const active = s === cur;
        return (
          <button key={s} data-testid={`stage-step-${s.toLowerCase()}`} onClick={() => click(s)} disabled={disabled}
            className={`flex min-h-[44px] shrink-0 items-center gap-1.5 rounded-lg border px-3 text-xs font-semibold transition-colors disabled:cursor-not-allowed disabled:opacity-50 ${
              active ? (s === "LOST" ? "border-rose-500 bg-rose-50 text-rose-700" : "border-[#1F9E7A] bg-[#1F9E7A] text-white")
                : done ? "border-[#1F9E7A]/30 bg-[#1F9E7A]/10 text-[#1F9E7A]" : "border-neutral-200 bg-white text-neutral-500 hover:border-neutral-300"}`}>
            {done && <Check className="h-3.5 w-3.5" />}{STAGE_LABELS[s]}
          </button>
        );
      })}
      <Dialog open={lossOpen} onOpenChange={setLossOpen}>
        <DialogContent data-testid="loss-reason-dialog" className="border-neutral-200 bg-white text-[#1A1A1A]">
          <DialogHeader><DialogTitle className="font-display">Disqualify lead</DialogTitle><DialogDescription className="text-neutral-500">A loss reason is mandatory for archival.</DialogDescription></DialogHeader>
          <ChipGroup options={LOSS_REASONS} value={reason} onChange={setReason} testPrefix="stage-loss-reason" />
          <Button data-testid="loss-reason-confirm" disabled={!reason} onClick={() => { onChange({ lifecycle_stage: "LOST", loss_reason: reason }); setLossOpen(false); }} className="bg-rose-600 hover:bg-rose-700">Mark as lost</Button>
        </DialogContent>
      </Dialog>
    </div>
  );
};
